import actionTypes from 'SRC/modules/redux/actionTypes'

export const setLocationsByCity = (locations) => {
  return {
    type: actionTypes.SET_LOCATIONS_BY_CITY,
    payload: locations
  }
}
